import {Breadcrumbs, FormDialog, Title} from '@management-ui/core';
import {Add} from '@mui/icons-material';
import {Box, Button} from '@mui/material';
import {reverse} from 'named-urls';
import * as React from 'react';
import {useCallback, useState} from 'react';
import {useHistory} from 'react-router-dom';
import TableHolder from '../../../../components/TableHolder';
import routes from '../../../../routes';
import ContactForm from '../../forms/ContactForm';
import Table from './Table';

const Contacts = ({archive = false}) => {
  const history = useHistory();
  const [showNew, setShowNew] = useState(false);

  const goToDetail = useCallback((contact) => {
    history.push(reverse(contact.archived ? routes.archive.contact.detail : routes.contacts.detail, {id: contact.id}));
  }, [history]);

  return (
    <>
      <Breadcrumbs crumbs={[{title: 'Contacts'}]}/>
      <Title title="Contacts">
        <Box display="flex" flex={1} justifyContent="flex-end">
          <Button variant="contained" startIcon={<Add/>} onClick={() => setShowNew(true)} color="success">
            Add New Contact
          </Button>
        </Box>
      </Title>
      <TableHolder>
        <Table
          archive={archive}
        />
      </TableHolder>
      <FormDialog
        title="Add New Contact"
        open={showNew}
        onClose={() => setShowNew(false)}
        render={(props) => (
          <ContactForm
            {...props}
            contact={{}}
            fieldSet="core"
            onSaved={goToDetail}/>
        )}
      />
    </>
  );
}

export default Contacts;
